import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import type { IOnboardingInput } from "@/features/lender-applications/types/lender-application";
import { mutationKeyMap } from "@/features/query-client";

import { changeOnboardingStep } from "../../api";
import { useLenderResponseOptimisticallyUpdate } from "../use-lender-response-optimistically-update";

interface IMutationInput {
  lenderCompanyId: number;
  lenderResponseId: number;
  data: IOnboardingInput;
}

type IMutationResult = Awaited<ReturnType<typeof changeOnboardingStep>>;

export const useChangeOnboardingStatus = () => {
  const optimisticallyUpdateLenderResponse =
    useLenderResponseOptimisticallyUpdate();

  return useMutation<IMutationResult, AxiosError, IMutationInput>({
    mutationKey: mutationKeyMap.changeOnboardingStatus,
    mutationFn: async ({ lenderResponseId, data, lenderCompanyId }) => {
      return await changeOnboardingStep(
        lenderCompanyId,
        lenderResponseId,
        data,
      );
    },
    onSuccess: () => {
      optimisticallyUpdateLenderResponse();
    },
  });
};
